import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import * as defaultStyles from '../../styles';
import { host } from '../../utilities/requests';
import { decrementPending, incrementPending } from "../../containers/actions";
export default class ExaminationAnalysis extends React.PureComponent {

    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
    }

    constructor(props) {
        super(props);
        this.interval = null;
        this.fetch = this.fetch.bind(this);
    }
    state = {
        data: null,
        intervalTime:Number(100)
    }
    componentWillMount() {
        this.startInterval();
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.intervalTime !== this.state.intervalTime) {
          this.startInterval();
        }
      }
    startInterval(){
        if(this.interval){
            clearInterval(this.interval);
        }
        this.interval = setInterval(()=>{
            this.fetch();
        } , this.state.intervalTime)
    }
    btnstyle = {
        padding: "0.5em",
        fontFamily: "IRANSans, Arial, sans-serif",
        fontSize: "0.9em",
        borderWidth: "medium",
        borderStyle: "none",
        borderColor: "currentcolor",
        cursor: " pointer",
        outline: "none",
        minWidth: "6em",
        margin: "0px 0.5em 0px 0px",
        backgroundColor: "white",
        color: "black",
        borderRadius: "0.15em",
        boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
    }

    async fetch() {
        try {
            var token = this.context.store.getState().get('application').get('token');
            await new Promise(async () => {
                const res = await fetch(`${host}/api/tasks/`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        "Authorization": `${token.get('tokenType')} ${token.get('accessToken')}`
                    }
                })
                const data = await res.json();
                let arr = [];
                let statusArr = [];
                data.map(item => {
                    let obj = {};
                    obj = {
                        examination_id: item?.examination_id?.persian(),
                        examination_title: item?.examination_title,
                        name: item?.name,
                        state: item?.state,
                        date_start: item?.date_start,
                        date_done: item.date_done,
                        progressPersent: item?.progress.percent,
                        terminateBtn: <button className='examination-analysis-revoke-btn' onClick={() => {
                            this.revoke(item.id)
                        }}>
                            {(item.state === "REVOKED" || item.state === "SUCCESS" || item.state === "FAILURE") ?
                                "حذف"
                                :
                                "لغو"
                            }
                        </button>
                    }
                    statusArr.push(item.state);
                    arr.push(obj);
                })
                this.setState({ ...this.state, data: arr });
                if(!(statusArr.includes("PENDING") || statusArr.includes("PROGRESS") || statusArr.includes("STARTED"))){
                    this.setState({...this.state ,intervalTime:Number(15000)})
                }
                else {
                    this.setState({...this.state ,intervalTime:Number(4000)})
                }
            })
        }
        catch (err) {
            console.log(err)
        }
    }

    async revoke(id) {
        try {
            this.context.store.dispatch(incrementPending());
            var token = this.context.store.getState().get('application').get('token');
            const payload = JSON.stringify({ id: id });
            const res = await fetch(`${host}/api/revoke_task/`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": `${token.get('tokenType')} ${token.get('accessToken')}`
                },
                body: payload
            });
            var result = await res.json();
            if (result) {
                clearInterval(this.interval);
                this.interval = setInterval(this.fetch, 4000);
            }
            this.context.store.dispatch(decrementPending());
        }
        catch (err) {
            console.log(err)
        }
    }

    async deleteAllSuccessTasks() {
        try {
            this.context.store.dispatch(incrementPending());
            var token = this.context.store.getState().get('application').get('token');
            const res = await fetch(`${host}/api/delete_analyze_tasks/`, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": `${token.get('tokenType')} ${token.get('accessToken')}`
                }
            });
            var result = await res.json();
            if (result) {
                clearInterval(this.interval);
                this.interval = setInterval(this.fetch, 4000);
            }
            this.context.store.dispatch(decrementPending());
        }
        catch (err) {
            console.log(err)
        }
    }

    listFields = [
        { field: "", label: "ردیف", height: 1, width: 1 },
        { field: "id", label: "شناسه آزمون", height: 1, width: 1 },
        { field: "examination_title", label: "عنوان", height: 1, width: 1 },
        { field: "name", label: "تحلیل", height: 1, width: 1 },
        { field: "state", label: "وضعیت", height: 1, width: 1 },
        { field: "date_start", label: "زمان شروع", height: 1, width: 2 },
        { field: "date_done", label: "زمان خاتمه", height: 1, width: 2 },
        { field: "progress", label: "میزان پیشرفت", height: 1, width: 2 },
        { field: "action", label: "عملیات", height: 1, width: 1 },
    ]

    tdStyle = {
        color: "#333",
        fontSize: "0.9em",
        textAlign: "center",
        border: "1px solid #eaeaea",
        padding: "0.4em"
    }

    render() {
        if (this.state.data) {
            return <div style={{ width: "100%" }}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                        style={{ ...this.btnstyle }}
                        onClick={this.props.handleShowAnalyzePage}
                    >
                        بازگشت
                    </button>
                </div>
                {this.state.data.length !== 0 ? <div style={{ display: "flex", justifyContent: "flex-start" }}>
                    <button
                        style={{
                            ...defaultStyles.button,
                            padding: '.50em',
                            boxSizing: 'border-box',
                            backgroundColor: '#dc3545',
                            color: 'white'
                        }}
                        onClick={() => { this.deleteAllSuccessTasks() }}
                    >
                        حذف تمامی تحلیل های انجام شده
                    </button>
                </div> :null}

                <div style={{ width: "100%", marginTop: "1em" }}>
                    {this.state.data.length === 0 ? <p style={{ textAlign: "center" , color:"#333" }}>تحلیلی برای مشاهده وجود ندارد</p> :
                        <table
                            style={{
                                borderCollapse: "collapse",
                                width: '100%',
                            }}>
                            <thead>
                                <tr >
                                    {this.listFields.map((item) => (
                                        <th
                                            style={{
                                                flex: `${item.width}`,
                                                border: "1px solid #eaeaea",
                                                color: "#7a7a7a",
                                                fontSize: "0.8em",
                                                padding: "0.4em",
                                            }}>
                                            {item.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {_.map(this.state.data, (item , index) => (
                                    <tr>
                                        <td style={this.tdStyle}>
                                            {(index + 1).persian()}
                                        </td>
                                        <td style={this.tdStyle}>
                                            {item.examination_id}
                                        </td>
                                        <td style={this.tdStyle}>
                                            {item.examination_title}
                                        </td>
                                        <td style={this.tdStyle}>
                                            {item.name}
                                        </td>
                                        <td style={{
                                            ...this.tdStyle,
                                            backgroundColor: `${item.state === "SUCCESS" ? "rgb(0,192,0)" : item.state === "PROGRESS" ? "#ffc107" : "#dc3545"}`,
                                            color: "#fff"
                                        }}>
                                            {window.gettext(item.state)}
                                        </td>
                                        <td style={this.tdStyle}>
                                            {item.date_start.toJalali().persian('YYYY-MM-DD HH:mm:ss')}
                                        </td>
                                        <td style={this.tdStyle}>
                                            {item.date_done != null ? item.date_done?.toJalali().persian('YYYY-MM-DD HH:mm:ss') : "-"}
                                        </td>
                                        <td style={this.tdStyle}>                                        
                                        <p>
                                            <div className='examination-analysis-progressbar' style={{ position: "relative" , 
                                                borderColor:(item.state === "REVOKED" || item.state === "FAILURE") ?  "#dc3545" : "rgb(50, 50, 255)" }}>
                                                <div style={{ width: `${(item.state === "REVOKED" || item.state === "FAILURE") ? "0%" : item.progressPersent}%` }}>
                                                </div>
                                                <p className='examination-analysis-progressbar-percent' 
                                                style={{
                                                    color:(item.state === "REVOKED" || item.state === "FAILURE") ?  "#dc3545" : "rgb(255, 255, 50)",
                                                    mixBlendMode:(item.state === "REVOKED" || item.state === "FAILURE") ? "normal" :"difference"
                                                    }}>
                                                    {`${(item.state === "REVOKED" || item.state === "FAILURE") ? "0".persian() :item.progressPersent}%`.persian()}
                                                    </p>
                                            </div>
                                        </p>
                                        </td>
                                        <td style={this.tdStyle}>
                                            {
                                                (item.state === "REVOKED" || item.state === "SUCCESS" || item.state === "FAILURE")
                                                    ? item.terminateBtn
                                                    : item.terminateBtn
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>}
                </div>
            </div>
        }
        else return <p>در حال بارگذاری...</p>
    }
}

